import { useAppMutation } from "../../../../../../http/useAppMutation.ts";

export const useCreateAssetComposition = () => {
  const { mutate: createAssetComposition } = useAppMutation({
    path: "assets/compositions",
    invalidate: [],
    waitForInvalidation: false,
  }).mutation;

  return {
    createAssetComposition: (assetUuid: string) => {
      createAssetComposition({
        asset_uuid: assetUuid,
      });
    },
  };
};
